(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gn-card-family-options"] && !Shopify.designMode) return;
  try {
    // GN Produktfamilien V1.4: zuerst Beschriftung kompakter, danach weniger Chips.
  // Einkaufsfunktionen, Varianten und Produktnavigation bleiben unveraendert.
  (() => {
    const selector = '.gncf[data-gncf-auto-fit]';
    const registered = new WeakSet();
    const pending = new Set();
    let frame = 0;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const fontSteps = (preferred, minimum) => {
      const sizes = [];
      for (let value = preferred; value >= minimum; value -= 0.5) {
        sizes.push(Math.round(value * 10) / 10);
      }
      if (!sizes.includes(minimum)) sizes.push(minimum);
      return [...new Set(sizes)];
    };
    const compactSteps = (preferred, minimum) => {
      const result = [];
      for (let value = preferred; value >= minimum; value -= 1) result.push(value);
      if (!result.includes(minimum)) result.push(minimum);
      return [...new Set(result)];
    };

    function fit(root) {
      if (!root.isConnected) return;
      const row = root.querySelector('.gncf__choices');
      const current = row?.querySelector('[data-gncf-current]');
      const more = row?.querySelector('[data-gncf-more]');
      if (!row || !current || !more) return;
      const siblings = [...row.querySelectorAll('[data-gncf-option]')];
      const mobile = isMobile();
      const configured = Number.parseInt(root.dataset[mobile ? 'gncfLimitMobile' : 'gncfLimitDesktop'], 10);
      const limit = Number.isFinite(configured) ? Math.max(1, configured) : (mobile ? 2 : 4);
      const maxOthers = Math.min(siblings.length, Math.max(0, limit - 1));
      const available = row.clientWidth;
      if (available <= 0) return;

      const css = getComputedStyle(root);
      const preferredFont = Number.parseFloat(css.getPropertyValue(mobile ? '--gncf-font-size-mobile' : '--gncf-font-size')) || (mobile ? 10 : 12);
      const preferredGap = Number.parseFloat(css.getPropertyValue(mobile ? '--gncf-gap-mobile' : '--gncf-gap')) || (mobile ? 4 : 6);
      const minFont = mobile ? 8 : 8.5;
      const fontCandidates = fontSteps(Math.max(minFont, preferredFont), minFont);
      const paddingCandidates = compactSteps(mobile ? 7 : 9, 3);
      const gapCandidates = compactSteps(Math.max(2, Math.round(preferredGap)), 2);

      row.style.visibility = 'hidden';
      siblings.forEach(chip => { chip.hidden = false; });
      more.hidden = false;

      // Die Zahl der sichtbaren Varianten hat Vorrang vor maximaler Schriftgroesse.
      // Alle Breiten werden mit echten Browser-Schriftmetriken gemessen.
      let chosen = null;
      for (let count = maxOthers; count >= 0 && !chosen; count--) {
        const remaining = siblings.length - count;
        more.textContent = `+${remaining}`;
        for (const font of fontCandidates) {
          root.style.setProperty('--gncf-fit-font-size', `${font}px`);
          const textWidths = [current, ...siblings.slice(0, count)].map(chip => {
            const span = chip.querySelector('.gncf__chip-text');
            return span ? span.getBoundingClientRect().width : chip.getBoundingClientRect().width;
          });
          const moreWidth = remaining ? more.getBoundingClientRect().width : 0;
          for (const padding of paddingCandidates) {
            const countChips = 1 + count;
            const badgesWidth = textWidths.reduce((sum, width) => sum + width, 0)
              + countChips * (2 * padding + 2) + moreWidth;
            for (const gap of gapCandidates) {
              const items = countChips + (remaining > 0 ? 1 : 0);
              const required = badgesWidth + Math.max(0, items - 1) * gap;
              if (required <= available - 2) {
                chosen = { count, font, padding, gap };
                break;
              }
            }
            if (chosen) break;
          }
          if (chosen) break;
        }
      }

      if (!chosen) chosen = { count: 0, font: minFont, padding: 3, gap: 2 };
      root.style.setProperty('--gncf-fit-font-size', `${chosen.font}px`);
      root.style.setProperty('--gncf-fit-padding', `${chosen.padding}px`);
      root.style.setProperty('--gncf-fit-gap', `${chosen.gap}px`);
      // GN Farben & Groessen hat eine !important-Ausrichtungsregel fuer die Zeile.
      // Der inline-Abstand gewinnt deshalb gezielt, ohne diese Ausrichtung zu aendern.
      row.style.setProperty('gap', `${chosen.gap}px`, 'important');
      siblings.forEach((chip, index) => { chip.hidden = index >= chosen.count; });
      const missing = siblings.length - chosen.count;
      more.hidden = missing === 0;
      if (missing > 0) {
        more.textContent = `+${missing}`;
        more.setAttribute('aria-label', `${missing} weitere Ausführungen auf der Produktseite ansehen`);
      }
      row.style.visibility = '';
    }

    function schedule(root) {
      if (!root?.isConnected) return;
      pending.add(root);
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const list = [...pending];
        pending.clear();
        for (const item of list) fit(item);
      });
    }
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) schedule(entry.target);
    });
    function register(root) {
      if (registered.has(root)) return;
      registered.add(root);
      observer.observe(root);
      schedule(root);
    }
    function scan(node) {
      if (!node || node.nodeType !== 1 && node.nodeType !== 9) return;
      if (node.matches?.(selector)) register(node);
      node.querySelectorAll?.(selector).forEach(register);
    }
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    window.addEventListener('resize', () => document.querySelectorAll(selector).forEach(schedule), { passive: true });
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => document.querySelectorAll(selector).forEach(schedule));
    }
    new MutationObserver(records => {
      for (const record of records) {
        for (const added of record.addedNodes) scan(added);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
